import axios from "axios";
import store from "../Store";
import { fs } from "../../data-services/firebase";

// Action types
export const EXPORT_JOB_START = "EXPORT_JOB_START";
export const EXPORT_JOB_PROGRESS = "EXPORT_JOB_PROGRESS";
export const EXPORT_JOB_COMPLETE = "EXPORT_JOB_COMPLETE";
export const EXPORT_JOB_CANCEL = "EXPORT_JOB_CANCEL";
export const EXPORT_JOB_ERROR = "EXPORT_JOB_ERROR";
export const EXPORT_JOB_RESET = "EXPORT_JOB_RESET";

let _firestoreUnsubscribe = null;

const cleanupSubscription = () => {
  if (_firestoreUnsubscribe) {
    _firestoreUnsubscribe();
    _firestoreUnsubscribe = null;
  }
};

export const startExportJob = (exportData) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  dispatch({ type: EXPORT_JOB_START, payload: exportData });

  axios
    .post(`${orgID}/dataExport`, exportData, {
      headers: { orgid: orgID },
    })
    .then((response) => {
      const jobId = response.data?.jobId;
      if (!jobId) {
        dispatch({
          type: EXPORT_JOB_ERROR,
          payload: { error: "Failed to start export job" },
        });
        return;
      }

      dispatch({
        type: EXPORT_JOB_PROGRESS,
        payload: {
          jobId,
          status: "pending",
          progress: {
            current: 0,
            total: exportData.requestedCount || 1000,
            phase: "pending",
          },
        },
      });

      // Subscribe to Firestore for real-time progress
      _firestoreUnsubscribe = fs
        .collection("export_jobs")
        .doc(jobId)
        .onSnapshot(
          (docSnapshot) => {
            const data = docSnapshot.data();
            if (!data) return;

            switch (data.status) {
              case "completed":
                dispatch({
                  type: EXPORT_JOB_COMPLETE,
                  payload: { jobId, url: data.url, progress: data.progress },
                });
                // Auto-download
                if (data.url) {
                  const a = document.createElement("a");
                  a.href = data.url;
                  a.download = data.url.split("/").pop();
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                }
                cleanupSubscription();
                break;

              case "error":
                dispatch({
                  type: EXPORT_JOB_ERROR,
                  payload: { jobId, error: data.error || "Export failed" },
                });
                cleanupSubscription();
                break;

              case "cancelled":
                dispatch({ type: EXPORT_JOB_CANCEL, payload: { jobId } });
                cleanupSubscription();
                break;

              default:
                // fetching, processing, uploading
                dispatch({
                  type: EXPORT_JOB_PROGRESS,
                  payload: {
                    jobId,
                    status: data.status,
                    progress: data.progress || {
                      current: 0,
                      total: 0,
                      phase: data.status,
                    },
                  },
                });
                break;
            }
          },
          (err) => {
            console.error(
              `[ExportActions] Firestore subscription error: ${err}`
            );
            dispatch({
              type: EXPORT_JOB_ERROR,
              payload: { error: "Lost connection to export progress" },
            });
            cleanupSubscription();
          }
        );
    })
    .catch((err) => {
      console.error(err);
      dispatch({
        type: EXPORT_JOB_ERROR,
        payload: {
          error: err.response?.data?.e || "Failed to start export",
        },
      });
    });
};

export const cancelExportJob = (jobId) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  cleanupSubscription();

  axios
    .post(
      `${orgID}/dataExport/cancel`,
      { jobId },
      { headers: { orgid: orgID } }
    )
    .then(() => {
      dispatch({ type: EXPORT_JOB_CANCEL, payload: { jobId } });
    })
    .catch((err) => {
      console.error(err);
      // Still cancel on UI side even if API fails
      dispatch({ type: EXPORT_JOB_CANCEL, payload: { jobId } });
    });
};

export const resetExportJob = () => (dispatch) => {
  cleanupSubscription();
  dispatch({ type: EXPORT_JOB_RESET });
};
